import React from 'react';
import { SvgIcon, Title } from '../';
import { $List, $Row, $Filename } from './styles';
export const CallDocuments = ({ documents = [], title = 'Call Documents', alternateTitle }) => {
    if (!documents.length)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Title, { alternate: alternateTitle, subTitle: !alternateTitle }, title),
        React.createElement($List, null, documents.map((document) => (React.createElement($Row, { key: document.id, href: document.url, target: '_blank', rel: 'noopener noreferrer' },
            React.createElement(SvgIcon, { name: 'download', size: 18 }),
            React.createElement($Filename, null, document.name || document.originalFilename)))))));
};
